import { render } from "./newsletter-modal.vue?vue&type=template&id=42b26cd1"
import script from "./newsletter-modal.vue?vue&type=script&lang=js"
export * from "./newsletter-modal.vue?vue&type=script&lang=js"

import "./newsletter-modal.vue?vue&type=style&index=0&id=42b26cd1&lang=scss"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__